export const SET_LOADING_DATA = '@justifications/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@justifications/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@justifications/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@justifications/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@justifications/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@justifications/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@justifications/SAVE_REQUEST';
export const SAVE_SUCCESS = '@justifications/SAVE_SUCCESS';

export const DELETE_ITEM = '@justifications/DELETE_ITEM';
export const EDIT_ITEM = '@justifications/EDIT_ITEM';

export const SEARCH = '@justifications/SEARCH';

export const SET_PAGE = '@justifications/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@justifications/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@justifications/SET_ORDER';
export const SET_ORDERBY = '@justifications/SET_ORDERBY';
